import { useEffect, useState } from 'react';
import { getReadersEmail, getReadersToken, onReadersAuthChange } from '../../Utils/ReadersAPI';

export const useReadersSession = () => {
  const read = () => ({ token: getReadersToken(), email: getReadersEmail() });
  const [session, setSession] = useState(read);
  useEffect(() => onReadersAuthChange(() => setSession(read())), []);
  return session;
};
